<script>
  export default {
    data () {
      return {}
    },
    computed: {},
    mounted () {
    },
    destroyed () {
    },
    methods: {},
    components: {}
  }
</script>

<template>
  <div class="bg-white b-b wrapper-md">
    <div class="row">
      <div class="col-md-3 col-sm-6 col-xs-7">
        <div class="m-t-sm">Administração de Contatos</div>
      </div>
      <div class="col-md-9 col-sm-6 col-xs-5">

      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// Header.vue?ca860d7e